import { render, staticRenderFns } from "./Check2FA.vue?vue&type=template&id=07fa6328&scoped=true"
import script from "./Check2FA.vue?vue&type=script&lang=js"
export * from "./Check2FA.vue?vue&type=script&lang=js"
import style0 from "./Check2FA.vue?vue&type=style&index=0&id=07fa6328&prod&scoped=true&lang=css"
import style1 from "./Check2FA.vue?vue&type=style&index=1&id=07fa6328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa6328",
  null
  
)

export default component.exports